(function($) {
    $(".comp_place_slider").each(function() {
        var $comp = $(this),
            $slider = $comp.find("[data-place-slider]"),
            $image_sliders = $comp.find("[data-place-image-slider]"),
            $nav = $comp.find("[data-place-nav-item]"),
            $download = $comp.find("[data-place-download]"),
            $download_title = $comp.find("[data-place-download-title]"),
            $initial_slide = parseInt($slider.data("initial-slide"), 10) || 0;

        function setActive(index) {
            var $slide = $slider.find(".elm_place_slide:not(.slick-cloned)").eq(index),
                title = $slide.data("place-button-title"),
                link = $slide.data("place-button-link");

            $nav.removeClass("mod--active").filter('[data-place-nav-item="' + index + '"]').addClass("mod--active");

            if (title) {
                $download_title.html(title);
            }

            if (link) {
                $download.attr("href", link);
            }

            $image_sliders.filter(".slick-initialized").slick("setPosition");
        }

        if (!$slider.length) {
            return;
        }

        $image_sliders.each(function() {
            var $image_slider = $(this);

            if ($image_slider.find(".elm_place_image").length > 1) {
                $image_slider.slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 500,
                    autoplay: false,
                    arrows: false,
                    dots: true
                });
            }
        });

        if ($slider.find(".elm_place_slide").length > 1) {
            $slider.on("init afterChange", function(event, slick, currentSlide) {
                setActive(typeof currentSlide === "number" ? currentSlide : slick.currentSlide);
            });

            $slider.slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplay: false,
                arrows: false,
                dots: false,
                initialSlide: $initial_slide
            });

            $nav.on("click keydown", function(event) {
                if (event.type === "keydown" && event.key !== "Enter" && event.key !== " ") {
                    return;
                }

                if (event.type === "keydown") {
                    event.preventDefault();
                }

                $slider.slick("slickGoTo", parseInt($(this).data("place-nav-item"), 10));
            });
        } else {
            setActive(0);
        }
    });
})(jQuery);
